module.exports = __webpack_public_path__ + "img/SPA.38a4bf86.png";